<div fxLayout="row" fxLayoutAlign="space-between center" class="header-create-section">
    <button (click)="goBack()" mat-button style="width: fit-content;" color="primary">
        <mat-icon color="primary">arrow_back</mat-icon>
        Regresar
    </button>
    <h2 class="title-page">Registrar expediente</h2>
    <div></div>
</div>

<div fxLayout="column" fxLayoutAlign="start">
    <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-start stretch"
         fxLayoutAlign.sm="space-start stretch" fxLayoutAlign.xs="space-around stretch">
        <mat-form-field appearance="outline" fxFlex="100%" class="px-4">
            <mat-label>* Seleccionar tipo de expediente</mat-label>
            <mat-select>
                <mat-option *ngFor="let configuracion of configuracionExpedienteOptions" [value]="configuracion.value"
                            (onSelectionChange)="onChangeSelectConfiguracion($event)">
                    {{configuracion.label}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>

<div fxLayout="row" fxLayoutAlign="end end">
    <button (click)="continuar()" [disabled]="idConfiguracion == null" mat-raised-button type="button" color="accent">
        Siguiente
    </button>
</div>
